import { getData, postData, putData, deleteData } from '../utils/fetch-api';

const baseUrl = `${process.env.REACT_APP_API_URL}`;

function createMessage(message) {
  return postData(`${baseUrl}/messages`, message);
}

function getMessage(id) {
  return getData(`${baseUrl}/messages/${id}`);
}

function getMessages({ page, paginate, isAddTimestamp, status, excludeFutureScheduled }) {
  let url = `${baseUrl}/messages?page=${page}&paginate=${paginate}`;

  if (status) {
    url = url.concat(`&status=${encodeURIComponent(status)}`);
  }

  // The Activity Log excludes still-pending scheduled pushes server-side so its
  // pagination + total count stay consistent with what it renders (those pushes
  // live in the Scheduled Pushes list). Past-due scheduled pushes still return.
  if (excludeFutureScheduled) {
    url = url.concat('&excludeFutureScheduled=true');
  }

  if (isAddTimestamp) {
    url = url.concat(`&timestamp=${(new Date()).getTime()}`);
  }

  return getData(url);
}

// WWW-15236 — scheduled pushes (status='scheduled') for the Scheduled Pushes list.
function getScheduledMessages() {
  return getData(`${baseUrl}/messages?page=1&paginate=100&status=scheduled&timestamp=${(new Date()).getTime()}`);
}

function getErrorMessages() {
  return getData(`${baseUrl}/messages?page=1&paginate=50&status=error`);
}

function deleteMessage(id) {
  return deleteData(`${baseUrl}/messages/${id}`);
}

function updateMessage(id, message) {
  return putData(`${baseUrl}/messages/${id}`, message);
}

function sendMessage(message) {
  return postData(`${baseUrl}/messages/send`, message).then(result => {
    return result;
  }, reason => {
    return Promise.reject(reason);
  });
}

const getPreviewImageUrl = (article) => postData(`${baseUrl}/messages/previewImage`, article);

const messageService = {
  createMessage,
  getMessage,
  getMessages,
  getScheduledMessages,
  getErrorMessages,
  updateMessage,
  deleteMessage,
  sendMessage,
  getPreviewImageUrl,
};

export default messageService;
